var Marionette = require('backbone.marionette');

var CommonUtils = require('../../utils/common-utils.js');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var RemoteSuggesterView = require('../common/remote-suggester-input.js');

var UploadSignedDocumentForm = Marionette.View.extend({
    template: require('../../templates/documents/upload-signed-document-form-view.html'),

    regions: {
        reviewerPerson: '#reviewer-person',
        reviewerOrg: '#reviewer-org'
    },

    childViewEvents: {
        'suggestor:selected:person': 'onPersonChanged',
        'suggestor:selected:organization': 'onOrganizationChanged'
    },

    ui: {
        status: '#status',
        fileSelector: '#file-input',
        statusTime: '#status-time',
        statusTimeLabel: '#status-time-label',
        comment: "#comment",

        reviewerPerson: '#reviewer-person',
        reviewerOrg: '#reviewer-org'
    },

    events: {
        'change @ui.status': 'onStatusChange',
        'keyup @ui.comment': 'onComment'
    },

    defaultParameters: {
        reviewerUUID: "",
        reviewerPersonId: "",
        reviewerOrgId: "",
        time: 0,
        comment: ""
    },

    parameters: {},

    templateContext: function () {
        var that = this;
        return {
            signStatusOfDocument: (that.document.object || {}).status
        }
    },

    initialize: function (options) {
        console.log("initialize");
        this.document = options.document;
        this.utils = new CommonUtils();
        this.status = 'sign';

        this.initReviewer(this.document);
    },

    initReviewer: function (document) {
        var reviewer = _.findWhere(document.object.reviewers, {status: "UNDER_REVIEW"})
            || _.findWhere(document.object.reviewers, {status: "IN_REVIEW"})
            || _.findWhere(document.object.reviewers, {status: "UNREVIEWED"})
            || _.findWhere(document.object.reviewers, {status: "SIGNED"});
        console.log(reviewer);

        this.defaultParameters.reviewerPersonId = reviewer.personId || "";
        this.defaultParameters.reviewerOrgId = reviewer.organizationId || "";
        this.defaultParameters.reviewerUUID = reviewer.uuid;

        this.reviewerPerson = _.isEmpty(reviewer.personId) ? null : _.find(document.relations, function (relation) {
            return relation.child.id == reviewer.personId;
        }).child;
        console.log(this.reviewerPerson);
        this.reviewerOrg = _.isEmpty(reviewer.organizationId) ? null : _.find(document.relations, function (relation) {
            return relation.child.id == reviewer.organizationId;
        }).child;
        console.log(this.reviewerOrg);
    },

    onRender: function () {
        var that = this;
        that.parameters = _.clone(that.defaultParameters);
        that.parameters.time = new Date().getTime();

        that.ui.fileSelector.fileinput({
            uploadLabel: 'Upload for sign',
            uploadUrl: "/api/document/upload/" + that.document.id + "/" + that.status,
            allowedFileExtensions: ["pdf"],
            dropZoneTitle: 'Drag & drop a PDF-file to here &hellip;',
            uploadExtraData: that.parameters
        });

        that.ui.fileSelector.on('fileuploaded', function (event, data, previewId, index) {

            $.notify("The document was "
                + (that.status == 'sign' ? 'signed' : (that.status == 'under_review' ? 'under review' : ""))
                + " successfully", "success");
            window.setTimeout(function () {
                that.triggerMethod("signed:document:uploaded", that.document);
            }, 0);
        });

        that.ui.statusTime.datetimepicker({
            showClear: true,
            showClose: true,
            useCurrent: false,
            format: 'MM/DD/YYYY hh:mm A',
            defaultDate: new Date(that.parameters.time),
            maxDate: new Date()
        });
        that.ui.statusTime.on("dp.change", function (e) {

            if (e.date) {
                that.parameters.time = e.date.valueOf();
            } else {
                that.parameters.time = 0;
            }
        })/*.on('dp.show', function () {
            return $(this).data('DateTimePicker').defaultDate(that.utils.getDateWithoutTime(new Date()));
        })*/;

        that.showReviewerPersonSelect(that.reviewerPerson);
        that.showReviewerOrgSelect(that.reviewerOrg);

        window.setTimeout(function () {
            that.disableReviewerInputs();
        }, 0);
    },

    showReviewerPersonSelect: function (defaultSelected) {
        var that = this;

        that.showChildView('reviewerPerson', new RemoteSuggesterView({
            maxNumberOfElements: 20,
            url: '/api/person/preview?page-size=' + 20 + '&sortby=name&like_name=~~~&object_mergeable=false',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data.filter(function (item) {
                    return item.object && item.object.isMd;
                });
            },
            getIdFn: function (element) {
                return element.id;
            },
            getValueFn: function (element) {
                return element.name;
            },
            classes: ["form-control"],
            placeholder: "Physician",
            findSelectedIdBySelectedIndex: function (arr, index) {
                return (arr[index] || {}).id;
            },
            tag: 'person',
            defaultSelected: defaultSelected
        }));
    },

    showReviewerOrgSelect: function (defaultSelected) {
        var that = this;

        that.showChildView('reviewerOrg', new RemoteSuggesterView({
            maxNumberOfElements: 20,
            url: '/api/organization/preview?page-size=' + 20 + '&sortby=name&like_name=~~~&type=organization',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data;
            },
            getIdFn: function (element) {
                return element.id;
            },
            getValueFn: function (element) {
                return element.name;
            },
            classes: ["form-control"],
            placeholder: "Organization",
            findSelectedIdBySelectedIndex: function (arr, index) {
                return (arr[index] || {}).id;
            },
            tag: 'organization',
            defaultSelected: defaultSelected
        }));
    },

    disableReviewerInputs: function () {
        this.ui.reviewerPerson.find('input').each(function () {
            $(this).attr('disabled', true);
        });

        this.ui.reviewerOrg.find('input').each(function () {
            $(this).attr('disabled', true);
        });
    },

    onStatusChange: function (event) {
        var value = event.target.value;
        this.status = value;
        this.ui.fileSelector.fileinput('refresh', {
            uploadLabel: 'Upload for ' + this.status,
            uploadUrl: "/api/document/upload/" + this.document.id + "/" + this.status
        });

        if (value === "sign") {
            this.ui.statusTimeLabel.text("Signature Date:");
            this.ui.reviewerPerson.find('input').each(function () {
                $(this).attr('disabled', true);
            });
        } else if (value == "under_review") {
            this.ui.statusTimeLabel.text("Under Review Date:");
            this.ui.reviewerPerson.find('input').each(function () {
                $(this).removeAttr('disabled');
            });
        }
    },

    onComment: function (e) {
        this.parameters.comment = e.target.value;
    },

    onPersonChanged: function (selected) {
        this.parameters.reviewerPersonId = selected;
    },

    onOrganizationChanged: function (selected) {

    }
});

module.exports = UploadSignedDocumentForm;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/upload-signed-document-form-view.js
// module id = 443
// module chunks = 0